'use client'

import { useCallback, type JSX } from 'react'

import Button from '@components/buttons/button'

import useApplyWithSonicApply from '@components/job/hooks/useApplyWithSonicApply'
import styles from './apply-and-reminder.module.scss'

type ApplyAndReminderProps = {
  jobId: string
  redirect: boolean
  externalJobUrl?: string | null
}

const ApplyAndReminder = ({ redirect, externalJobUrl }: ApplyAndReminderProps): JSX.Element => {
  const applyWithSonicApply = useApplyWithSonicApply()

  const handleRedirect = useCallback(() => {
    if (redirect && externalJobUrl) {
      window.open(externalJobUrl, '_blank')
    }
  }, [redirect, externalJobUrl])

  return (
    <div className={styles.apply}>
      <Button
        className={styles['apply-btn']}
        variant="yellow"
        size="lg"
        onClick={redirect ? handleRedirect : applyWithSonicApply}
      >
        Apply now
      </Button>
    </div>
  )
}

export default ApplyAndReminder
